import React from "react";
import { Phone } from "lucide-react";

/**
 * En-tête réduit des pages d'atterrissage Google Ads.
 *
 * Pas de navigation : sur une page payée au clic, chaque lien sortant est une
 * occasion de perdre le visiteur avant qu'il n'ait rempli quoi que ce soit.
 * Il ne reste que l'identité (obligatoire, et rassurante) et le numéro, qui
 * est lui-même une conversion — une partie du public appelle plutôt que de
 * remplir un formulaire.
 *
 * Le logo n'est volontairement pas un lien vers l'accueil, pour la même
 * raison. L'accès au reste du site passe par le pied de page.
 */
const EnteteLanding = () => (
  <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
    <div className="container mx-auto px-4">
      <div className="flex items-center justify-between py-3">
        <div className="flex items-center gap-3">
          <img
            src="/images/logo-tef.jpg"
            width="184"
            height="80"
            loading="eager"
            alt="Transition Énergie France"
            className="w-20 h-14 sm:w-28 sm:h-16 object-contain"
          />
          <p className="text-xs sm:text-sm font-medium leading-tight">
            <span className="text-blue-700 font-bold">AMO</span>{" "}
            <span className="text-gray-900">agréé ANAH</span>
            <span className="block text-gray-700">Île-de-France</span>
          </p>
        </div>

        <a
          href="tel:0939035444"
          className="flex items-center gap-2 bg-orange-700 hover:bg-orange-800 text-white px-4 py-3 rounded-lg font-semibold transition-colors min-h-[48px]"
        >
          <Phone aria-hidden="true" className="h-5 w-5" />
          <span className="hidden sm:inline">09 39 03 54 44</span>
          <span className="sm:hidden">Appeler</span>
        </a>
      </div>
    </div>
  </header>
);

export default EnteteLanding;
